import {
  LayoutDashboard,
  Factory,
  ClipboardCheck,
  Boxes,
  Search,
  Recycle,
  ShoppingCart,
  Truck,
  Container,
  Users,
  Building2,
  Contact,
  Settings,
  Layers,
  MapPin,
  BookOpen,
  Wallet,
  FileText,
  Receipt,
  Banknote,
  CreditCard,
  type LucideIcon,
} from "lucide-react";

export type NavItem = {
  title: string;
  to: string;
  icon: LucideIcon;
  enabled?: boolean;
};

export type NavGroup = {
  title: string;
  items: NavItem[];
};

export const navGroups: NavGroup[] = [
  {
    title: "Operations",
    items: [
      { title: "Dashboard", to: "/dashboard", icon: LayoutDashboard, enabled: true },
      { title: "Planning", to: "/planning", icon: Factory, enabled: true },
      { title: "Production", to: "/production", icon: Factory, enabled: true },
      { title: "Quality", to: "/quality", icon: ClipboardCheck, enabled: true },
      { title: "Inventory", to: "/inventory", icon: Boxes, enabled: true },
      { title: "Lookup", to: "/lookup", icon: Search, enabled: true },
      { title: "Scrap", to: "/scrap", icon: Recycle, enabled: true },
    ],
  },
  {
    title: "Masters",
    items: [
      { title: "Materials", to: "/materials", icon: Layers, enabled: true },
      { title: "Locations", to: "/locations", icon: MapPin, enabled: true },
      { title: "Machines", to: "/machines", icon: Factory, enabled: true },
      { title: "Fleet", to: "/fleet", icon: Container, enabled: true },
    ],
  },
  {
    title: "Sales",
    items: [
      { title: "Clients", to: "/clients", icon: Contact, enabled: true },
      { title: "Quotations", to: "/quotations", icon: FileText, enabled: true },
      { title: "Sales Orders", to: "/sales-orders", icon: ShoppingCart, enabled: true },
      { title: "Dispatch", to: "/dispatch", icon: Truck, enabled: true },
    ],
  },
  {
    title: "Procurement",
    items: [
      { title: "Purchase", to: "/purchase", icon: ShoppingCart, enabled: true },
      { title: "Vendors", to: "/vendors", icon: Building2, enabled: true },
    ],
  },
  {
    title: "Finance",
    items: [
      { title: "Master ledger", to: "/books", icon: BookOpen, enabled: true },
      { title: "Invoices", to: "/invoices", icon: Receipt, enabled: true },
      { title: "Payments", to: "/payments", icon: Banknote, enabled: true },
      { title: "Credit notes", to: "/credit-notes", icon: CreditCard, enabled: true },
      { title: "Expenses", to: "/expenses", icon: Wallet, enabled: true },
    ],
  },
  {
    title: "Admin",
    items: [
      { title: "Users", to: "/users", icon: Users, enabled: true },
      { title: "Settings", to: "/settings", icon: Settings, enabled: true },
    ],
  },
];

export const commandRoutes = navGroups.flatMap((group) =>
  group.items.filter((item) => item.enabled !== false).map((item) => ({
    title: item.title,
    to: item.to,
    group: group.title,
  })),
);
